/* ============================================================
 *  Taunus Timepieces — Umschalter für die Dunkelansicht
 * ------------------------------------------------------------
 *  Das Setzen des Modus passiert bereits im Kopf der Seite
 *  (theme.liquid), damit beim Laden nichts aufblitzt. Hier geht
 *  es nur noch um den Knopf im Seitenkopf.
 * ============================================================ */
(function () {
  "use strict";

  var SPEICHER = "tt-theme";
  var wurzel = document.documentElement;

  function geraetIstDunkel() {
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
  }

  function istDunkel() {
    var gewaehlt = wurzel.getAttribute("data-tt-theme");
    if (gewaehlt === "dark") return true;
    if (gewaehlt === "light") return false;
    return geraetIstDunkel();
  }

  function beschriftung(knopf) {
    var text = istDunkel() ? "Zur hellen Ansicht wechseln" : "Zur dunklen Ansicht wechseln";
    knopf.setAttribute("aria-label", text);
    knopf.setAttribute("title", text);
    knopf.setAttribute("aria-pressed", istDunkel() ? "true" : "false");
  }

  function umschalten(knopf) {
    var neu = istDunkel() ? "light" : "dark";
    wurzel.setAttribute("data-tt-theme", neu);
    try { localStorage.setItem(SPEICHER, neu); } catch (e) { /* privates Fenster */ }
    beschriftung(knopf);
  }

  var SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<g class="tt-icon-moon"><path d="M20 14.5A8.2 8.2 0 0 1 9.5 4 8.5 8.5 0 1 0 20 14.5z"/></g>' +
      '<g class="tt-icon-sun">' +
        '<circle cx="12" cy="12" r="4.1"/>' +
        '<path d="M12 2.4v2.2M12 19.4v2.2M4.2 12H2M22 12h-2.2M6.5 6.5 4.9 4.9M19.1 19.1l-1.6-1.6M17.5 6.5l1.6-1.6M4.9 19.1l1.6-1.6"/>' +
      '</g>' +
    '</svg>';

  function einbauen() {
    if (document.querySelector(".tt-theme-toggle")) return true;

    var platz = document.querySelector(".tt-nav-right");
    if (!platz) return false;

    var knopf = document.createElement("button");
    knopf.type = "button";
    knopf.className = "tt-theme-toggle";
    knopf.innerHTML = SVG;
    beschriftung(knopf);
    knopf.addEventListener("click", function () { umschalten(knopf); });

    /* Vor den Warenkorb, damit Kontakt und Warenkorb ihre Plätze behalten. */
    var warenkorb = platz.querySelector(".tt-cart");
    if (warenkorb) platz.insertBefore(knopf, warenkorb);
    else platz.appendChild(knopf);

    /* Folgt der Besucher der Geräteeinstellung, soll der Knopf
       mitwandern, wenn das Gerät abends umschaltet. */
    if (window.matchMedia) {
      var abfrage = window.matchMedia("(prefers-color-scheme: dark)");
      var reagieren = function () {
        if (!wurzel.getAttribute("data-tt-theme")) beschriftung(knopf);
      };
      if (abfrage.addEventListener) abfrage.addEventListener("change", reagieren);
      else if (abfrage.addListener) abfrage.addListener(reagieren);
    }

    return true;
  }

  if (!einbauen()) {
    /* Der Kopf wird von einer Section gerendert; im Theme-Editor
       kann er nach dem Laden neu aufgebaut werden. */
    document.addEventListener("DOMContentLoaded", einbauen);
    document.addEventListener("shopify:section:load", einbauen);
    var versuche = 0;
    var takt = setInterval(function () {
      if (einbauen() || ++versuche > 20) clearInterval(takt);
    }, 250);
  }
})();
